import { NgModule } from '@angular/core';
import { CheckoutComponentsModule } from './components';
import { CheckoutCoreModule } from './core';
import { CheckoutOccModule } from './occ';

@NgModule({
  imports: [CheckoutComponentsModule, CheckoutCoreModule, CheckoutOccModule],
})
export class CheckoutModule {}
